module.exports = __webpack_public_path__ + "static/media/onboarding_1.3adef19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/onboarding_1.png
// module id = 431
// module chunks = 49